import { _TemplateModalFormComponent } from "./_template-modal-form/_template-modal-form.component";
import { AccountManagerModalFormComponent } from "./account-manager-modal-form/account-manager-modal-form.component";
import { ActivityHeatmapComponent } from "./_time-line/timeline-activity-heatmap/timeline-activity-heatmap.component";
import { AddressModalFormComponent } from "./address-modal-form/address-modal-form.component";
import { AddTicketNoteModalFormComponent } from "./_tickets/add-ticket-note-modal-form/add-ticket-note-modal-form.component";
import { AlertCountryCoverageComponent } from "src/app/forms-modal/alert-country-coverage/alert-country-coverage.component";
import { AlertModalEditFormComponent } from "src/app/forms-modal/alert-modal-edit-form/alert-modal-edit-form.component";
import { AlertsModalFormComponent } from "./alerts-modal-form/alerts-modal-form.component";
import { AlertThresholdPipe } from "./alert-threshold.pipe";
import { BulkOrderModalFormComponent } from "src/app/forms-modal/_provisioning/provision-bulk-order-modal-form/provision-bulk-order-modal-form.component";
import { BulkSimActionsModalFormComponent } from "./_manage-sim/bulk-sim-actions-modal-form/bulk-sim-actions-modal-form.component";
import { BulkUserActionsModalFormComponent } from "./_user/bulk-user-actions-modal-form/bulk-user-actions-modal-form.component";
import { ChartComponent } from "ng-apexcharts";
import { ChatGptModalFormComponent } from "./_ai/chat-gpt-modal-form/chat-gpt-modal-form.component";
import { CommonModule } from "@angular/common";
import { CommunicationComposeModalFormComponent } from "./_communication/communication-compose-modal-form/communication-compose-modal-form.component";
import { CommunicationGridModalFormComponent } from "./_communication/communication-grid-modal-form/communication-grid-modal-form.component";
import { CommunicationModalFormComponent } from "./_communication/communication-modal-form/communication-modal-form.component";
import { CompanyModalFormComponent } from "./_company/company-modal-form/company-modal-form.component";
import { CompanyModalFormMoreComponent } from "./_company/company-modal-form-more/company-modal-form-more.component";
import { CompletedModalFormComponent } from "./_pop-ups/completed-modal-form/completed-modal-form.component";
import { ConfirmationModalFormComponent } from "./_pop-ups/confirmation-modal-form/confirmation-modal-form.component";
import { CountryGroupModalEditFormComponent } from "src/app/forms-modal/country-groups-modal-edit-form/country-groups-modal-edit-form.component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { defineElement } from "@lordicon/element";
import { DownloadCentreModalFormComponent } from "./_file-transfers/download-centre-modal-form/download-centre-modal-form.component";
import { DropdownsModule } from "../core/dropdowns/dropdowns.module";
import { DxNumberBoxModule } from "devextreme-angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridViewModule } from "src/app/core/grid-view/grid-view.module";
import { ImagesModalFormComponent } from "./_pop-ups/images-modal-form/images-modal-form.component";
import { ImeilockingModalFormComponent } from "./imei-locking-modal-form/imei-locking-modal-form.component";
import { InformationModalFormComponent } from "./_pop-ups/information-modal-form/information-modal-form.component";
import { InputModalFormComponent } from "./_inputs/input-form/input-modal-form.component";
import { InventoryAssetModalFormComponent } from "./_inventory/inventory-asset-modal-form/inventory-asset-modal-form.component";
import { LicencesCompanyAllocatedCardsComponent } from "./_licence/licences-company-allocated/licences-company-allocated-cards/licences-company-allocated-cards.component";
import { LicencesCompanyVisibleModalFormSearchComponent } from "./_licence/licences-company-visible/licences-company-visible-modal-form-search/licences-company-visible-modal-form-search.component";
import { LicenceSystemModalFormComponent } from "./_licence/licence-system-modal-form/licence-system-modal-form.component";
import { LocationWebhookModalFormComponent } from "./location-webhook-modal-form/location-webhook-modal-form.component";
import lottie from 'lottie-web';
import { ManageEsimModalFormComponent } from "./_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component";
import { ManageEsimModalFormMoreComponent } from "./_manage-sim/manage-esim-modal-form-more/manage-esim-modal-form-more.component";
import { ManageTicketsModalFormComponent } from "./_tickets/manage-tickets-modal-form/manage-tickets-modal-form.component";
import { MapCompanyModalFormComponent } from "./_location-services/map-company-modal-form/map-company-modal-form.component";
import { ModalComponentsModule } from "../core/modal-components/modal-components.module";
import { NgApexchartsModule } from "ng-apexcharts";
import { NgbModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { OurDirectivesModule } from "../core/our-directives/our-directives.module";
import { PageComponentsModule } from "../core/page-components/page-components.module";
import { PagesEmbeddedModule } from "../pages-embedded/pages-embedded.module";
import { PartnerLinkModalFormComponent } from "./_partners/partner-link-modal-form/partner-link-modal-form.component";
import { ProvisionBulkModalFormComponent } from 'src/app/forms-modal/_provisioning/provision-bulk-modal-form/provision-bulk-modal-form.component'
import { ProvisionModalFormComponent } from "./_provisioning/provision-modal-form/provision-modal-form.component";
import { RedeployModalFormComponent } from 'src/app/forms-modal/_provisioning/redeploy-modal-form/redeploy-modal-form.component'
import { ReservationModalFormComponent } from "./reservation-modal-form/reservation-modal-form.component";
import { RiskIntelligenceSharedComponentsModule } from "src/app/shared/components/risk-intelligence/risk-intelligence-shared-components.module";
import { RisklineAlertModalFormComponent } from "./riskline-alert-modal-form/riskline-alert-modal-form.component";
import { RisklineTravelSearchModalFormComponent } from "./riskline-travel-search-modal-form/riskline-travel-search-modal-form.component";
import { RisklineTripReadyModalFormComponent } from "./riskline-trip-ready-modal-form/riskline-trip-ready-modal-form.component";
import { SharedModule } from "src/app/shared/shared.module";
import { StatementMenuModalFormComponent } from "./_pop-ups/statement-menu-modal-form/statement-menu-modal-form.component";
import { TariffsRentalDetailsModalFormComponent } from "./_tariffs/tariffs-rental-details-modal-form/tariffs-rental-details-modal-form.component";
import { TariffsRentalModalFormComponent } from "./_tariffs/tariffs-rental-modal-form/tariffs-rental-modal-form.component";
import { TariffsUsageModalFormComponent } from "./_tariffs/tariffs-usage-modal-form/tariffs-usage-modal-form.component";
import { TariffsUsageSchemeModalFormComponent } from "./_tariffs/tariffs-usage-scheme-modal-form/tariffs-usage-scheme-modal-form.component";
import { TariffsUsageSchemeRateModalFormComponent } from "./_tariffs/tariffs-usage-scheme-rate-modal-form/tariffs-usage-scheme-rate-modal-form.component";
import { TariffsUsageZoneModalFormComponent } from "./_tariffs/tariffs-usage-zone-modal-form/tariffs-usage-zone-modal-form.component";
import { TemplateEmailModalFormComponent } from "./template-email-modal-form/template-email-modal-form.component";
import { TemplateNotificationModalFormComponent } from "./template-notification-modal-form/template-notification-modal-form.component";
import { TemplateSMSModalFormComponent } from "./template-sms-modal-form/template-sms-modal-form.component";
import { TicketModalFormComponent } from "./_tickets/ticket-modal-form/ticket-modal-form.component";
import { TimelineEsimModalFormComponent } from "./_time-line/timeline-esim-modal-form/timeline-esim-modal-form.component";
import { ToastsContainer } from "src/app/shared/toast/toasts-container.component";
import { TypesMessageModalFormComponent } from "./types-message-modal-form/types-message-modal-form.component";
import { UnreserveBulkModalFormComponent } from 'src/app/forms-modal/_provisioning/unreserve-bulk-modal-form/unreserve-bulk-modal-form.component';
import { UploadCentreModalFormComponent } from "./_file-transfers/upload-centre-modal-form/upload-centre-modal-form.component";
import { UploadCentreModalFormSearchComponent } from "./_file-transfers/upload-centre-modal-form-search/upload-centre-modal-form-search.component";
import { UsageLimitsModalFormComponent } from "./usage-limits-modal-form/usage-limits-modal-form.component";
import { UserGroupModalEditFormComponent } from "src/app/forms-modal/user-groups-modal-edit-form/user-groups-modal-edit-form.component";
import { UserModalFormComponent } from "./_user/user-modal-form/user-modal-form.component";
import { UserModalFormMoreComponent } from "./_user/user-modal-form-more/user-modal-form-more.component";
import { UserModalFormSearchComponent } from "./_user/user-modal-form-search/user-modal-form-search.component";
import { WarningModalFormComponent } from "./_pop-ups/warning-modal-form/warning-modal-form.component";
import { Widget_NoFormsModalModule_Module } from "../shared/widget-no-formsmodalmodule/widget-no-formsmodalmodule.module";

@NgModule({
  declarations: [
    _TemplateModalFormComponent,
    AccountManagerModalFormComponent,
    ActivityHeatmapComponent,
    AddressModalFormComponent,
    AddTicketNoteModalFormComponent,
    AlertCountryCoverageComponent,
    AlertModalEditFormComponent,
    AlertsModalFormComponent,
    AlertThresholdPipe,
    BulkOrderModalFormComponent,
    BulkSimActionsModalFormComponent,
    BulkUserActionsModalFormComponent,
    ChatGptModalFormComponent,
    CommunicationComposeModalFormComponent,
    CommunicationGridModalFormComponent,
    CommunicationModalFormComponent,
    CompanyModalFormComponent,
    CompanyModalFormMoreComponent,
    CompletedModalFormComponent,
    ConfirmationModalFormComponent,
    CountryGroupModalEditFormComponent,
    DownloadCentreModalFormComponent,
    ImagesModalFormComponent,
    ImeilockingModalFormComponent,
    InformationModalFormComponent,
    InputModalFormComponent,
    InventoryAssetModalFormComponent,
    LicencesCompanyAllocatedCardsComponent,
    LicencesCompanyVisibleModalFormSearchComponent,
    LicenceSystemModalFormComponent,
    LocationWebhookModalFormComponent,
    ManageEsimModalFormComponent,
    ManageEsimModalFormMoreComponent,
    ManageTicketsModalFormComponent,
    MapCompanyModalFormComponent,
    PartnerLinkModalFormComponent,
    ProvisionBulkModalFormComponent,
    ProvisionModalFormComponent,
    RedeployModalFormComponent,
    ReservationModalFormComponent,
    RisklineAlertModalFormComponent,
    RisklineTravelSearchModalFormComponent,
    RisklineTripReadyModalFormComponent,
    StatementMenuModalFormComponent,
    TariffsRentalDetailsModalFormComponent,
    TariffsRentalModalFormComponent,
    TariffsUsageModalFormComponent,
    TariffsUsageSchemeModalFormComponent,
    TariffsUsageSchemeRateModalFormComponent,
    TariffsUsageZoneModalFormComponent,
    TemplateEmailModalFormComponent,
    TemplateNotificationModalFormComponent,
    TemplateSMSModalFormComponent,
    TicketModalFormComponent,
    TimelineEsimModalFormComponent,
    TypesMessageModalFormComponent,
    UnreserveBulkModalFormComponent,
    UploadCentreModalFormComponent,
    UploadCentreModalFormSearchComponent,
    UsageLimitsModalFormComponent,
    UserGroupModalEditFormComponent,
    UserModalFormComponent,
    UserModalFormMoreComponent,
    UserModalFormSearchComponent,
    WarningModalFormComponent
  ],
  imports: [
    ChartComponent,
    CommonModule,
    DropdownsModule,
    DxNumberBoxModule,
    FormsModule,
    GridViewModule,
    ModalComponentsModule,
    NgApexchartsModule,
    NgbModule,
    NgbTooltipModule,
    NgSelectModule,
    OurDirectivesModule,
    PageComponentsModule,
    PagesEmbeddedModule,
    ReactiveFormsModule,
    RiskIntelligenceSharedComponentsModule,
    SharedModule,
    ToastsContainer,
    Widget_NoFormsModalModule_Module
  ],
  exports: [
    //_TemplateModalFormComponent, //CRN_20250520 - No need to export
    AccountManagerModalFormComponent,
    AddressModalFormComponent,
    AddTicketNoteModalFormComponent,
    AlertCountryCoverageComponent,
    AlertModalEditFormComponent,
    AlertsModalFormComponent,
    AlertThresholdPipe,
    BulkOrderModalFormComponent,
    BulkSimActionsModalFormComponent,
    BulkUserActionsModalFormComponent,
    ChatGptModalFormComponent,
    CommunicationComposeModalFormComponent,
    CommunicationGridModalFormComponent,
    CommunicationModalFormComponent,
    CompanyModalFormComponent,
    CompanyModalFormMoreComponent,
    CompletedModalFormComponent,
    ConfirmationModalFormComponent,
    CountryGroupModalEditFormComponent,
    DownloadCentreModalFormComponent,
    ImagesModalFormComponent,
    ImeilockingModalFormComponent,
    InformationModalFormComponent,
    InputModalFormComponent,
    InventoryAssetModalFormComponent,
    LicencesCompanyAllocatedCardsComponent,
    LicencesCompanyVisibleModalFormSearchComponent,
    LicenceSystemModalFormComponent,
    LocationWebhookModalFormComponent,
    ManageEsimModalFormComponent,
    ManageEsimModalFormMoreComponent,
    ManageTicketsModalFormComponent,
    MapCompanyModalFormComponent,
    PartnerLinkModalFormComponent,
    ProvisionBulkModalFormComponent,
    ProvisionModalFormComponent,
    RedeployModalFormComponent,
    ReservationModalFormComponent,
    RisklineAlertModalFormComponent,
    RisklineTravelSearchModalFormComponent,
    RisklineTripReadyModalFormComponent,
    StatementMenuModalFormComponent,
    TariffsRentalDetailsModalFormComponent,
    TariffsRentalModalFormComponent,
    TariffsUsageModalFormComponent,
    TariffsUsageSchemeModalFormComponent,
    TariffsUsageSchemeRateModalFormComponent,
    TariffsUsageZoneModalFormComponent,
    TemplateEmailModalFormComponent,
    TemplateNotificationModalFormComponent,
    TemplateSMSModalFormComponent,
    TicketModalFormComponent,
    TimelineEsimModalFormComponent,
    TypesMessageModalFormComponent,
    UnreserveBulkModalFormComponent,
    UploadCentreModalFormComponent,
    UploadCentreModalFormSearchComponent,
    UsageLimitsModalFormComponent,
    UserGroupModalEditFormComponent,
    UserModalFormComponent,
    UserModalFormMoreComponent,
    UserModalFormSearchComponent,
    WarningModalFormComponent
  ],
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class FormsModalModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
